"use client";
import {
  useRadioStore
} from "../__chunks/BE2VUBZ4.js";
import {
  RadioContextProvider
} from "../__chunks/BGBYET7R.js";
import "../__chunks/B7UTNDHN.js";
import "../__chunks/AMMIPFT4.js";
import "../__chunks/APTFW6PT.js";
import "../__chunks/RTNCFSKZ.js";
import "../__chunks/5CPL3B7G.js";
import "../__chunks/VOQWLFSQ.js";
import "../__chunks/5GGHRIN3.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/radio/radio-provider.tsx
import { jsx } from "react/jsx-runtime";
function RadioProvider(props = {}) {
  const store = useRadioStore(props);
  return /* @__PURE__ */ jsx(RadioContextProvider, { value: store, children: props.children });
}
export {
  RadioProvider
};
